"use client"

import { useCart } from "@lib/context/cart-context"
import CartDropdown from "../cart-dropdown"

export default function CartButton({
  className,
  showLabel = false,
}: {
  className?: string
  showLabel?: boolean
} = {}) {
  const { cart, totalItems } = useCart()

  return (
    <CartDropdown
      cart={cart}
      totalItems={totalItems}
      className={className}
      showLabel={showLabel}
    />
  )
}
